// extracted by mini-css-extract-plugin
export default {"entityfield__detailed":"EntityField_entityfield__detailed__HLvUG"};